__turbopack_context__.v({
  "backdrop": "SelectInput-module__fUvTqq__backdrop",
  "emptyHint": "SelectInput-module__fUvTqq__emptyHint",
  "menu": "SelectInput-module__fUvTqq__menu",
  "menuHint": "SelectInput-module__fUvTqq__menuHint",
  "option": "SelectInput-module__fUvTqq__option",
  "optionList": "SelectInput-module__fUvTqq__optionList",
  "optionSelected": "SelectInput-module__fUvTqq__optionSelected",
  "searchIcon": "SelectInput-module__fUvTqq__searchIcon",
  "searchInput": "SelectInput-module__fUvTqq__searchInput",
  "searchRow": "SelectInput-module__fUvTqq__searchRow",
  "trigger": "SelectInput-module__fUvTqq__trigger",
  "triggerChevron": "SelectInput-module__fUvTqq__triggerChevron",
  "triggerDisabled": "SelectInput-module__fUvTqq__triggerDisabled",
  "triggerError": "SelectInput-module__fUvTqq__triggerError",
  "triggerPlaceholder": "SelectInput-module__fUvTqq__triggerPlaceholder",
  "triggerValue": "SelectInput-module__fUvTqq__triggerValue",
});
